import CreateServicePlanDiscountCodeControl from '@/ui/components/createServicePlanDiscountCode/CreateServicePlanDiscountCodeControl';
import { FC } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router';
import AuthenticatedPageWrapper from '../pageWrappers/authenticatedPageWrapper/AuthenticatedPageWrapper';

const NewDiscountCodePage: FC = () => {
  const history = useHistory();

  return (
    <>
      <Helmet title={'New Discount Code'} />

      <AuthenticatedPageWrapper
        className="service-plan-page"
        breadcrumbItems={[
          { label: 'Back', to: '/service-plans/discount-codes' },
          { label: 'New Discount Code' },
        ]}
      >
        <div className="typography:prose">
          <h1 className="px-8 py-4">New Service Plan Discount Code</h1>
        </div>
        <div className="p-4">
          <CreateServicePlanDiscountCodeControl
            onCreateSuccess={() =>
              history.push(`/service-plans/discount-codes`)
            }
          />
        </div>
      </AuthenticatedPageWrapper>
    </>
  );
};

export default NewDiscountCodePage;
